import React from 'react';
import { QSpacer, QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { Header } from '../../containers/header';

const EditUserHeader = (): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <QStack direction={['row']}>
      <Header content={t('editUser.header')} />
      <QSpacer />
    </QStack>
  );
};

export default EditUserHeader;
